import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./components/style.css";

import { Route, BrowserRouter, Routes } from "react-router-dom";

import {
  Login,
  Cadastro,
  Redefinir,
  Home,
  Form1,
  Form2,
  Form3,
  Form4,
  Form5,
  Form6,
  Form7,
  Aceite,
  Contato,
  Contrato,
  Financeiro,
  Introducao,
  Instrucoes,
  Recibo,
  Inicio,
  Vinculo,
} from "./pages";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/redefinir" element={<Redefinir />} />
        <Route path="/home" element={<Home />} />
        <Route path="/form1" element={<Form1 />} />
        <Route path="/form2" element={<Form2 />} />
        <Route path="/form3" element={<Form3 />} />
        <Route path="/form4" element={<Form4 />} />
        <Route path="/form5" element={<Form5 />} />
        <Route path="/form6" element={<Form6 />} />
        <Route path="/form7" element={<Form7 />} />
        <Route path="/aceite" element={<Aceite />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/contrato" element={<Contrato />} />
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/introducao" element={<Introducao />} />
        <Route path="/instrucoes" element={<Instrucoes />} />
        <Route path="/recibo" element={<Recibo />} />
        <Route path="/inicio" element={<Inicio />} />
        <Route path="/vinculo" element={<Vinculo />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
